import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

import logo from 'assets/logo-icons/bedrock.svg';
import './selfRegister.scss';

const API_BASE = process.env.REACT_APP_API_V1_END_POINT;

const SelfRegister = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const token = params.get('token');

  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    gender: '',
    dateOfBirth: '',
    password: '',
    confirmPassword: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const onChange = (field) => (e) =>
    setForm((prev) => ({ ...prev, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (form.password !== form.confirmPassword) {
      return setError('Passwords do not match');
    }
    if (form.password.length < 8 || !/[a-zA-Z]/.test(form.password) || !/[0-9]/.test(form.password)) {
      return setError('Password must be at least 8 characters and contain at least 1 letter and 1 number');
    }

    setSubmitting(true);
    try {
      await axios.post(
        `${API_BASE}/myemployee/employee/public/self-register?token=${token}`,
        form,
      );
      setSuccess(true);
    } catch (err) {
      const msg =
        err?.response?.data?.message || 'Registration failed. Please try again.';
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  if (!token) {
    return (
      <div className="self-reg">
        <div className="self-reg__card">
          <img src={logo} alt="Bedrock" className="self-reg__logo" />
          <p className="self-reg__error-msg">Invalid registration link.</p>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="self-reg">
        <div className="self-reg__card">
          <img src={logo} alt="Bedrock" className="self-reg__logo" />
          <h2 className="self-reg__title">Registration Successful</h2>
          <p className="self-reg__success-msg">
            Your account has been created. You can now log in to the Riverr app with your email <strong>{form.email}</strong>.
          </p>
          <a
            href={API_BASE?.includes('dev') ? 'https://dev.riverr.health' : 'https://riverr.health'}
            className="self-reg__app-link"
          >
            Open Riverr App
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="self-reg">
      <div className="self-reg__card">
        <img src={logo} alt="Bedrock" className="self-reg__logo" />
        <h2 className="self-reg__title">Employee Self-Registration</h2>

        <form onSubmit={handleSubmit} className="self-reg__form">
          <div className="self-reg__row">
            <div className="self-reg__field">
              <label>First Name *</label>
              <input
                type="text"
                value={form.firstName}
                onChange={onChange('firstName')}
                required
              />
            </div>
            <div className="self-reg__field">
              <label>Last Name *</label>
              <input
                type="text"
                value={form.lastName}
                onChange={onChange('lastName')}
                required
              />
            </div>
          </div>

          <div className="self-reg__field">
            <label>Email *</label>
            <input
              type="email"
              value={form.email}
              onChange={onChange('email')}
              required
            />
          </div>

          <div className="self-reg__row">
            <div className="self-reg__field">
              <label>Gender *</label>
              <select value={form.gender} onChange={onChange('gender')} required>
                <option value="">Select</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div className="self-reg__field">
              <label>Date of Birth *</label>
              <input
                type="date"
                value={form.dateOfBirth}
                onChange={onChange('dateOfBirth')}
                required
              />
            </div>
          </div>

          <div className="self-reg__field">
            <label>Password *</label>
            <input
              type="password"
              value={form.password}
              onChange={onChange('password')}
              minLength={8}
              maxLength={40}
              required
            />
            <span className="self-reg__hint">
              Password must be at least 8 characters and contain at least 1 letter and 1 number.
            </span>
          </div>

          <div className="self-reg__field">
            <label>Confirm Password *</label>
            <input
              type="password"
              value={form.confirmPassword}
              onChange={onChange('confirmPassword')}
              minLength={4}
              maxLength={40}
              required
            />
          </div>

          {error && <p className="self-reg__error-msg">{error}</p>}

          <button
            type="submit"
            className="self-reg__submit"
            disabled={submitting}
          >
            {submitting ? 'Registering...' : 'Register'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SelfRegister;
